import { render, staticRenderFns } from "./wallet_master.vue?vue&type=template&id=1bbb2884"
import script from "./wallet_master.vue?vue&type=script&lang=js"
export * from "./wallet_master.vue?vue&type=script&lang=js"
import style0 from "./wallet_master.vue?vue&type=style&index=0&id=1bbb2884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports